export const SCREEN_SIZES = ['xs', 'sm', 'md', 'lg', 'xl'] as const;
export type TScreenSize = typeof SCREEN_SIZES[number];
